import Swal from "sweetalert2";
import React, { useState } from "react";

const EnquiryForms = () => {
    const [data, setData] = useState({
        name: "",
        number: "",
        email: "",
        shipment: "",
        weight: ""
    });

    const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "name") {
      value = value.replace(/[^a-zA-Z ]/g, "").replace(/^\s+|\s{2,}/g, " ");
    }

    if (name === "number") {
        value = value.replace(/\D/g, "").slice(0, 10);
        if (value.length === 1 && !/[6-9]/.test(value)) {
        return;
        }
    }
    if (name === "shipment") {
      value = value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*?)\..*/g, "$1")
        .slice(0, 10);
    }

    setData({ ...data, [name]: value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        formData.append("entry.1066364640", data.name);
        formData.append("entry.2051178473", data.number);
        formData.append("entry.1540682144", data.email);
        formData.append("entry.1370340581", data.shipment);
        formData.append("entry.1232288671", data.weight);

        await fetch(
            "https://docs.google.com/forms/d/e/1FAIpQLSfUUqBOLiBuN0Zz35hXqGwktMVzOMjvt-EbhzDk-jEct1QSSg/formResponse",
            {
                method: "POST",
                body: formData,
                mode: "no-cors"
            }
        );

        setData({
            name: "",
            number: "",
            email: "",
            shipment: "",
            weight: ""
        });
        Swal.fire({
            title: "Form Submitted!",
            text: "Thank you! Your details have been submitted successfully. We’ll get back to you shortly.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false
        });
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="name">Full Name <span>*</span></label>
                            <input name="name" value={data.name} onChange={handleChange} className="form-control"  placeholder="e.g. Rohit Sharma" required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="number">Contact Number <span>*</span></label>
                            <input name="number" value={data.number} maxLength={10} onChange={handleChange} className="form-control" placeholder="e.g. 9876543210" required />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="shipment">Shipments Per Month <span>*</span></label>
                            <input name="shipment" value={data.shipment} onChange={handleChange} className="form-control" placeholder="e.g. 70 kg" required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="day">Enter Weight Slab</label>
                            <select name="weight" className="form-select form-control" value={data.weight} onChange={handleChange}>
                                <option value="" disabled>Enter Weight Slab</option>
                                <option value="0.5kg">0.5Kg</option>
                                <option value="1Kg">1Kg</option>
                                <option value="2Kg">2Kg</option>
                            </select>
                        </div>
                    </div>
                </div>
                <button type="submit" className="btn btn-primary">Submit Details <i className="fas fa-arrow-right"></i></button>
            </form>
        </>
    );
};

export default EnquiryForms;  